import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SettingsService} from '../core/settings.service';

@Injectable()
export class DemoService {
  constructor(
    private httpClient: HttpClient,
    private settingsService: SettingsService
  ) {}

  createDemo(type: number, status: number, credentials: any) {
    return this.httpClient.post(
      this.settingsService.getSetting('apiHost') + 'demo',
      {
        type: type,
        status: status,
        credentials: credentials
      }
    );
  }

  getDemo(id: string) {
    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'demos/' + id
    );
  }

  getDemoList(type: number) {
    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'demos/' + type + '/list'
    );
  }
}
